import { render, staticRenderFns } from "./StoreIncome.vue?vue&type=template&id=0fc43df0"
import script from "./StoreIncome.vue?vue&type=script&lang=js"
export * from "./StoreIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports